export default __webpack_public_path__ + "static/media/us_0.cd6f1bdc.mp3";